import { render, staticRenderFns } from "./surfaceSamplesTableOverview.vue?vue&type=template&id=c07593ac"
import script from "./surfaceSamplesTableOverview.vue?vue&type=script&lang=js"
export * from "./surfaceSamplesTableOverview.vue?vue&type=script&lang=js"
import style0 from "./surfaceSamplesTableOverview.vue?vue&type=style&index=0&id=c07593ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports